import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
      },
    };
  }

  static updateSuggestions(requestData) {
    return axios.post(`${ENV.appointmentApiBase}/note_suggestion/update`, requestData, this.requestConfig());
  }
}

export default Service;
